import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/components/shared/ThemeProvider";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`inline-flex h-11 items-center gap-2 rounded-full border border-[#d8bd7a] bg-white px-3 text-sm font-semibold text-[#8a5b00] shadow-sm transition hover:bg-[#fff8eb] dark:border-[#8a6a24] dark:bg-[#11100d] dark:text-[#f2c95d] dark:hover:bg-[#1b1710] ${className}`}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Light mode" : "Dark mode"}
    >
      <span className="grid h-7 w-7 place-items-center rounded-full bg-[#fff2d8] text-[#b77900] dark:bg-[#251b08] dark:text-[#f2c95d]">
        {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      </span>
      <span className="hidden xl:inline">{isDark ? "Light" : "Dark"}</span>
    </button>
  );
}
